module.exports = __webpack_public_path__ + "9cad35c46f775585c615fb8a5b1dc354.svg";